import React from 'react'


// Opción B (si colocas la imagen en public/yo.jpeg): usar src="/yo.jpeg" en el <img />

const Hero: React.FC = () => {
  return (
    <section id="inicio" style={{
      background: 'linear-gradient(to right, #2563eb, #1e40af)',
      color: '#ffffff',
      padding: '5rem 0'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{
            width: '100%',
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            <h1 style={{
              fontSize: '2.25rem',
              fontWeight: 700,
              marginBottom: '1rem',
              lineHeight: 1.2
            }}>
              Rafael Antonio<br />
              <span style={{ color: '#bfdbfe' }}>Alvarez Vera</span>
            </h1>
            <h2 style={{
              fontSize: '1.25rem',
              marginBottom: '1.5rem',
              color: '#dbeafe'
            }}>
              Ingeniero en Sistemas Computacionales
            </h2>
            <p style={{
              fontSize: '1.125rem',
              marginBottom: '2rem',
              color: '#dbeafe',
              maxWidth: '32rem',
              margin: '0 auto 2rem'
            }}>
              Ingeniero de software con especialidad en Ciberseguridad y nociones de DevOps. Acompaño proyectos desde el diseño,
              desarrollo e implementación, incluyendo dominios, servidores en la nube, Kubernetes y Docker.
            </p>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <a
                href="#contacto"
                style={{
                  backgroundColor: '#ffffff',
                  color: '#2563eb',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                  fontWeight: 600,
                  textDecoration: 'none',
                  transition: 'background-color 200ms',
                  display: 'inline-block'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.backgroundColor = '#f0f9ff';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.backgroundColor = '#ffffff';
                }}
              >
                Contáctame
              </a>
              <a
                href="#proyectos"
                style={{
                  backgroundColor: 'transparent',
                  color: '#ffffff',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                  fontWeight: 600,
                  border: '2px solid #ffffff',
                  textDecoration: 'none',
                  transition: 'all 200ms',
                  display: 'inline-block'
                }}
                onMouseEnter={(e) => {
                  const t = e.currentTarget as HTMLElement;
                  t.style.backgroundColor = '#ffffff';
                  t.style.color = '#2563eb';
                }}
                onMouseLeave={(e) => {
                  const t = e.currentTarget as HTMLElement;
                  t.style.backgroundColor = 'transparent';
                  t.style.color = '#ffffff';
                }}
              >
                Ver Proyectos
              </a>
            </div>
          </div>

          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <div style={{ position: 'relative' }}>
              {/* Anillo blanco */}
              <div style={{
                width: '16rem',
                height: '16rem',
                backgroundColor: '#ffffff',
                borderRadius: '9999px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto'
              }}>
                {/* Círculo azul que actúa como "viewport" — overflow hidden para recortar la img */}
                <div style={{
                  width: '15rem',
                  height: '15rem',
                  backgroundColor: '#2563eb',
                  borderRadius: '9999px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden' // <-- importante: recorta la imagen a círculo
                }}>
                  <img
                    // Si usas la Opción B (public) reemplaza {yo} por "/yo.jpeg"
                    src="/IA.jpeg"
                    alt="Foto de Rafael Antonio Alvarez"
                    loading="lazy"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', // <-- cover para que ocupe todo y se recorte correctamente
                      display: 'block',
                      borderRadius: '9999px' // redundante por el overflow pero ayuda en algunos navegadores
                    }}
                  />
                </div>
              </div>

              <div style={{
                position: 'absolute',
                top: '-1rem',
                right: '-1rem',
                width: '5rem',
                height: '5rem',
                backgroundColor: '#fef3c7',
                borderRadius: '9999px',
                opacity: 0.2
              }} />

              <div style={{
                position: 'absolute',
                bottom: '-1rem',
                left: '-1rem',
                width: '4rem',
                height: '4rem',
                backgroundColor: '#d1fae5',
                borderRadius: '9999px',
                opacity: 0.2
              }} />
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Hero
